import {
  comercialChamadoPendingCopy,
  isComercialChamadoPendingAction,
  resolveComercialChamadoPending,
} from '@/components/Comercial/comercialChamadoPending.util'
import { getDirectProposalPendingAlert } from '@/components/Deals/directProposalJourneyAlert.util'
import type { FinanceRequestRow } from '@/services/financeService'
import type { Deal } from '@/types'
import { dealsPagePathForDeal } from '@/utils/dealsPageNavigation'

export type OperacaoPendenciaTone = 'danger' | 'warning'

export type OperacaoPendenciaItem = {
  id: string
  tone: OperacaoPendenciaTone
  title: string
  subtitle: string
  href: string
  priority: number
}

function chamadoPendenciaPriority(tone: OperacaoPendenciaTone): number {
  return tone === 'danger' ? 0 : 1
}

export function buildChamadoPendencias(requests: FinanceRequestRow[]): OperacaoPendenciaItem[] {
  return requests
    .filter((row) => isComercialChamadoPendingAction(row.type, row.status))
    .map((row) => {
      const kind = resolveComercialChamadoPending({ type: row.type, status: row.status })!
      const copy = comercialChamadoPendingCopy(kind)
      const dealId = row.project?.deal?.id ?? null
      const href =
        kind === 'adjust_proposal' && dealId
          ? dealsPagePathForDeal(dealId)
          : '/financeiro'

      return {
        id: `chamado-${row.id}`,
        tone: kind === 'adjust_proposal' ? 'danger' : 'warning',
        title: copy.title,
        subtitle: row.clientDisplay?.label ?? row.protocol,
        href,
        priority: chamadoPendenciaPriority(kind === 'adjust_proposal' ? 'danger' : 'warning'),
      }
    })
}

export function buildDealPendencias(deals: Deal[]): OperacaoPendenciaItem[] {
  const items: OperacaoPendenciaItem[] = []

  for (const deal of deals) {
    if (deal.financeAwaitingCloser) {
      items.push({
        id: `finance-${deal.id}`,
        tone: 'warning',
        title: 'Financeiro aguardando você',
        subtitle: deal.empresaNome || deal.nome,
        href: dealsPagePathForDeal(deal.id),
        priority: 2,
      })
    }

    const directAlert = getDirectProposalPendingAlert(deal)
    if (directAlert) {
      items.push({
        id: `proposal-${deal.id}`,
        tone: directAlert.tone === 'danger' ? 'danger' : 'warning',
        title: directAlert.label,
        subtitle: deal.empresaNome || deal.nome,
        href: dealsPagePathForDeal(deal.id),
        priority: directAlert.tone === 'danger' ? 0 : 1,
      })
    }
  }

  return items
}

export function mergeOperacaoPendencias(
  chamados: OperacaoPendenciaItem[],
  deals: OperacaoPendenciaItem[],
  limit = 5,
): OperacaoPendenciaItem[] {
  return [...chamados, ...deals]
    .sort((a, b) => a.priority - b.priority || a.title.localeCompare(b.title))
    .slice(0, limit)
}
